import { AddonOption, AddonCategory } from 'Types/Aggregates';

export const groupAddons = (
  arr: Array<AddonOption> | undefined,
  isAutomatics?: boolean,
  isBoth?: boolean
): AddonCategory[] => {
  const categories: Array<AddonCategory> = [];
  const categoryIds: Array<string | number> = [];

  if (!arr) {
    return categories;
  }

  arr.forEach((a) => {
    if (
      (!isBoth && isAutomatics && !a.category.is_automatics) ||
      (!isAutomatics && a.category.is_automatics)
    ) {
      return;
    }

    if (categoryIds.indexOf(a.category.id) === -1) {
      categories.push({
        name: a.category.name,
        id: a.category.id,
        addons: [],
        order: a.category.order,
      });
      categoryIds.push(a.category.id);
    }
  });

  // Sort addons by order, with id as secondary key for stability
  arr.sort((a, b) => {
    if (a.order !== b.order) {
      return a.order - b.order;
    }
    return a.id - b.id;
  });

  arr.forEach((a) => {
    const cat = categories.find((c) => c.id === a.category.id);
    if (cat) {
      cat.addons.push(a);
    }
  });

  categories.sort((a, b) => (b.order > a.order ? -1 : 1));
  return categories;
};

export default {};
